import { ImageGallery } from '../../components/ImageGallery';
import { ProductContentPanel } from '../../composites/ProductContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { ProductDetailTemplateProps } from './ProductDetailTemplate.types';

export function ProductDetailTemplate({
  images = [],
  onBack,
  previousImageLabel,
  nextImageLabel,
  goToImageLabel,
  ...contentProps
}: ProductDetailTemplateProps) {
  return (
    <SplitLayout
      left={
        <ImageGallery
          images={images}
          onBack={onBack}
          sticky
          prevLabel={previousImageLabel}
          nextLabel={nextImageLabel}
          goToImageLabel={goToImageLabel}
        />
      }
      right={<ProductContentPanel {...contentProps} />}
    />
  );
}
